import videojs from 'video.js';

import * as Dom from '../utils/dom';

const VjsComponent = videojs.getComponent('Component');

class VjsScrubber extends VjsComponent {
  constructor(player, options) {
    super(player, options);
    this.setEventHandlers();
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }

  setDragging(value) {
    this.dragging = value;
  }

  isDragging() {
    return this.dragging;
  }

  setCurrentTime(value) {
    this.handleTimeChange(value);
  }

  getCurrentTime() {
    return this.currentTime;
  }

  createEl(tag = 'div', props = {}, attributes = {}) {
    const el = super.createEl(tag, props, attributes);

    el.style.width = '12px';
    el.style.left = '0';
    el.style.height = '22px';
    el.style.backgroundColor = '#46ffA0';
    el.style.position = 'absolute';
    el.style.zIndex = '10';
    el.style.cursor = 'ew-resize';

    return el;
  }

  setEventHandlers() {
    this.on('mousedown', this.handleMouseDown.bind(this));
    this.on('mouseup', this.handleMouseUp);
    this.on('mousemove', this.handleMouseMove);
  }

  handleMouseDown(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setDragging(true);
    this.update(evt);

    const doc = this.el().ownerDocument;
    this.on(doc, 'mousemove', this.handleMouseMove);
    this.on(doc, 'mouseup', this.handleMouseUp);
  }

  handleMouseUp(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setDragging(false);

    const doc = this.el().ownerDocument;
    this.off(doc, 'mousemove', this.handleMouseMove);
    this.off(doc, 'mouseup', this.handleMouseUp);
  }

  handleMouseMove(evt) {
    evt.preventDefault();
    this.update(evt);
  }

  update(evt) {
    if (!this.isDragging()) return;

    const el = this.el();

    // Position relative to parent (progress bar)
    const parent = el.parentElement;
    const { x } = Dom.getPointerPosition(parent, evt);
    const timeAlpha = Math.min(Math.max(x, 0), 100);
    const newTime = this.player().duration() * timeAlpha;

    if (this.options().changeHandler) {
      this.options().changeHandler.call(this, newTime);
    }
  }

  handleTimeChange(newTime) {
    const el = this.el();
    const parent = el.parentElement;

    const duration = this.player().duration();

    // Remove half of the width in order to center
    const offset = el.clientWidth / 2 / parent.clientWidth;

    // Cap to duration constraints
    this.currentTime = Math.min(Math.max(newTime, 0), duration);

    // Set position
    const timeAlpha = this.currentTime / duration;
    el.style.left = `${(timeAlpha - offset) * 100}%`;
  }
}

export default VjsScrubber;
